import { Component, Input, OnInit, OnDestroy, ViewChild, ElementRef, AfterViewInit} from '@angular/core';


@Component({
    selector: 'app-video-player',
    templateUrl: './video-player.component.html',
    styleUrls: ['./video-player.component.scss']
})
export class VideoPlayerComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() title: string | null = null;
    @Input() description: string | null = null;
    @Input() thumbnail: string | null = null;
    @Input() url: { tc: string, sc: string, en: string } | null = null;
    @ViewChild('videoElement') videoElement!: ElementRef<HTMLVideoElement>;

    selectedUrl: string | null = null;
    isExpand = true;
    isShowPlayer = false;

    constructor() {}

    ngOnInit() {}

    ngAfterViewInit() {}

    ngOnDestroy() {
        this.stopVideo();
      }

      playVideo() {
        if (this.videoElement) {
          this.videoElement.nativeElement.play()
            .catch(error => {
              console.error('Error trying to play the video:', error);
            });
        }
      }

      stopVideo() {
        if (this.videoElement) {
          this.videoElement.nativeElement.pause();
        }
        this.selectedUrl = null;
      }

      disableRightClick(event: MouseEvent) {
        event.preventDefault();
      }

      onHeaderClick() {
        this.isExpand = !this.isExpand;
      }

      onOpenPlayer(lang) {
        this.selectedUrl = this.url[lang];
        this.isShowPlayer = true;

        if (this.videoElement) {
            this.videoElement.nativeElement.load();
            this.playVideo();
        }
      }

      onClosePlayer() {
        this.isShowPlayer = false;
        this.stopVideo();
      }
}
